module.exports = __webpack_public_path__ + "static/media/the-method.ca24b063.jpg";